<template>

    <!-- nuevas -->
    <div class="row mb-5">
            <!-- mensajes -->
            
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        {{cardheader}}
                    </div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-4 pb-3">									
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fa fa-shopping-basket" aria-hidden="true"></i></div>
                                        </div>
                                        <input type="text" class="form-control" placeholder="Buscar una orden..." v-model="searchModel">
                                    </div>																											
                                </div>
                                <div class="col pb-3">
                                    <div class="float-right">									
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-primary" @click="testAudio">probar audio</button>
                                            <button type="button" class="btn btn-primary" @click="loadNuevas">Actualizar<i class="fa fa-refresh" aria-hidden="true" style="margin-left: 5px"></i></button>
                                            <button type="button" class="btn btn-primary"><i class="fa fa-sliders" aria-hidden="true"></i></button>										
                                        </div>		
                                    </div>
                                </div>																																
                            </div>
                        </div>

                        <div class="col-md-12">												
                <table class="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th> Cliente </th>
                            <th class="d-sm-none" > Dirección </th>
                            <th> Fecha </th>
                            <th> Hora </th>
                            <th class="d-sm-none" > Cantidad </th>
                            <th> Opciones </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in items" v-bind:key="row.id" class="table-warning" >
                        <td>{{row.id}}</td>
                        <td>{{row.billing.first_name +" "+row.billing.last_name }}</td>
                        <td class="d-sm-none" >{{row.billing.address_1}}</td>
                        <td> {{ fDate(row.created) }} </td> 
                        <td> {{ fTime(row.created) }} </td> 
                        <td class="d-sm-none" >{{row.total}}</td>
                        <td>
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button type="button" class="btn btn-primary waves-effect waves-light" @click="verOrderModal(row, true)" > Ver </button>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div>

                    </div>
                </div>
            </div>
            
        </div>
        <!-- end nuevas -->


</template>


<script>
/* global io */
/* eslint no-undef: "error" */
/* eslint no-unused-vars: "error" */

const SIO_SERVER = 'http://socket.branches.com.mx:8080'
const SOCKET_URL = 'http://socket.branches.com.mx:8080/proceso'
const SOCKET_KEY = ''



import AlertModal from '@/components/AlertModal.vue';
import WooOrderModal from '@/components/Woocommerce/OrderModal.vue';
import WooOrdenes from '@/modules/woocommerce/models/WooOrders.js';

import ChatfuelMsgs from '@/components/Woocommerce/ChatfuelMsgs.vue';

import moment from 'moment'



export default {
  name: 'itemsListModal',
  mounted(){

  },
  props:{
    cardheader: String,
    items: Array
  },
  data() {
	
    return {

		
      };
  },
  components: {

  },
  methods: {
	  
	setTitle(){
        
    }
   
  },
};
</script>
